module.exports = __webpack_public_path__ + "static/img/30.7be61bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background/30.jpg
// module id = HyY4
// module chunks = 0